/* eslint-disable react/no-danger */
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { mainCardTypes } from '../../constants';
import { cardSettingsScreens } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { OrderReplacementImage } from '../../../../assets/components';

const OrderReplacementCard = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const { state, openScreen } = useContext(CardSettingsContext);
  const [supportInfo, setSupportInfo] = useState({});

  const screenOptions = state?.screenOptions;
  const cardStatus = state?.cardStatus;
  const cardProvider = state?.user?.cardProvider;

  const [settings] = useSetting('server_configurations', [
    'optimus_support_phone_number',
    'support_phone_number',
    'card_support_email_address',
  ]);

  useEffect(() => {
    const numberSetting = settings?.support_phone_number;

    const phoneNumber = numberSetting;

    const supportEmail = settings?.card_support_email_address;

    setSupportInfo({
      supportEmail,
      phoneNumber,
    });
  }, [cardProvider, settings]);

  const renderContactInfo = () =>
    translate(
      screenOptions?.allow_card_replacement_order
        ? 'card_replacement_contact_content_2'
        : 'card_replacement_contact_content',
      {
        email: `<span class="text-primary text-f5 text-decoration-underline">${supportInfo?.supportEmail}</span>`,
        number: `<span class="text-primary text-f5 text-decoration-underline">${supportInfo?.phoneNumber}</span>`,
      }
    );

  return (
    <MainBodyLayout
      withBack={screenOptions?.withBack}
      onPrevClick={() => openScreen(cardSettingsScreens.REPORT_CARD_ISSUE, screenOptions)}
      title={
        screenOptions?.success
          ? translate('card_disabled')
          : translate('manage_card_report_card_issue')
      }>
      {screenOptions?.success ? (
        <div className="text-f5  mt-4 mb-4">
          {translate('successfully_reported', { state: screenOptions?.state })}
        </div>
      ) : (
        <div className="text-f5 mt-5 mb-4 fw-bold">{translate('order_replacement_card')}</div>
      )}
      <div
        className="text-f5 nobr pe-5"
        dangerouslySetInnerHTML={{ __html: renderContactInfo() }}
      />

      <OrderReplacementImage cardNetwork={cardStatus?.network || ''} cardProvider={cardProvider} />

      {screenOptions?.allow_card_replacement_order && (
        <div
          className={`d-flex flex-row mt-5 pt-3 ${
            isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
          }`}
          style={{ bottom: '0', left: '0', zIndex: 100 }}>
          <button
            onClick={() => {
              history.push('/dashboard/card/order-card', {
                isCardReplacement: true,
                mainCardType: mainCardTypes.PHYSICAL,
                ...screenOptions,
              });
            }}
            className="btn border-grey border text-f5 mt-4 w-100"
            type="button">
            {translate('order_replacement_card')}
          </button>
        </div>
      )}
    </MainBodyLayout>
  );
};

export default OrderReplacementCard;
